import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Container, type ContainerProps, Flex } from '@/ui';
import { SlimHeader } from '../SlimHeader';

type Props = ContainerProps & {
  children?: ReactNode;
};

export const AuthLayout = ({ children, ...props }: Props) => {
  return (
    <>
      {/* Lifted into its own stacking position so a page below can lay a
          full-bleed backdrop behind it (see the Dates split on /auth) without
          the logo disappearing under it. */}
      <SlimHeader position="relative" rightColumn="none" zIndex={1} />

      <Container
        as={Flex}
        flex="1"
        justifyContent="center"
        // 40px a side costs a narrow phone a fifth of its width, so the gutter
        // stays modest until there is room for it.
        px={{ base: 5, sm: 10 }}
        py={10}
        variant="max"
        {...props}
      >
        {children ? children : <Outlet />}
      </Container>
    </>
  );
};
